module.exports = __webpack_public_path__ + "static/media/Avatar-10.04be2625.png";